export const CUSTOM_SELECT = 'custom-select';

export const SELECT_DROPDOWN_LIST = 'select-dropdown__list';

export const SELECT_DROPDOWN = 'select-dropdown';

export const SELECT_DROPDOWN_ITEM = 'select-dropdown-item';

export const SELECT_DROPDOWN_BUTTON = 'select-dropdown__button';

export const SELECT_DROPDOWN_LIST_ITEM = 'select-dropdown__list-item';

export const SELECT_INDICATOR = 'select-dropdown__indicator';

export const OPTION_ADDITIONAL_LABEL = 'additional-option-label';

export const SELECTED_CLASS = 'selected';
